export default __webpack_public_path__ + "static/media/ralph.6aca0c80.svg";